import React, { ReactNode, useState, useEffect } from "react";
import { IFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { Container } from "./styles";
import { EditFuncionarioModal } from "../EditFuncionarioModal";
import { IFuncionarioPrefeitura } from "../../Hooks/funcionarioPrefeitura";
interface Props {
  children: ReactNode;
  funcionario: IFuncionarioCartorio | IFuncionarioPrefeitura;
  handleCheckModalOpen(): void;
}

export function HelperFuncionariosOperation({
  children,
  funcionario,
  handleCheckModalOpen,
}: Props) {
    
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {}, [openModal]);

    

  return (
    <>
      <Container
        onClick={() => {
          setOpenModal(true);
          handleCheckModalOpen();
        }}
      >
        {children}
      </Container>

      <EditFuncionarioModal
        item={funcionario}
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          handleCheckModalOpen();
        }}
      />
    </>
  );
}
